export default {
  section: 'Movimientos',
  loading: 'Cargando movimientos...',
  headers: {
    date: 'Pago eato',
    status: 'Estatus de la orden',
    total: 'Total de la orden con impuestos',
    folio: 'Factura No.',
    fiscal: 'Folio fiscal',
    datePayment: 'Pago proveedor',
    invoice: 'Total de la factura',
    amount: 'Total de la orden sin impuestos',
    concept: 'Concepto',
    payment: 'Importe',
    amountPaid: 'Monto abonado',
    balance: 'Saldo',
    actions: 'Archivo'
  }
}
